import { SelectionData, LangState } from "./types/ui.types";
import {
  FIRM_INDUSTRY_VALUES,
  FIRM_OPTIONS_DELIMITER,
  makeOptionHelpers,
} from "@eip/shared/utils/firmProfileOptions";

// Canonical ElevateIP industry list — values single-sourced in
// @eip/shared/utils/firmProfileOptions (review R21) so the server validates
// against the exact same list this multi-select offers. Mirrors the founder
// application "Industry" question (founderProfileBase.ts) so firm and founder
// industry values stay consistent. Only the French display text lives here;
// the parse/serialize/display machinery comes from the shared
// makeOptionHelpers factory (C16/C31 — languageOptions.ts is the twin).
const INDUSTRY_FR_TEXT: Record<string, string> = {
  "Agriculture": "Agriculture",
  "Advanced Materials & Manufacturing: Excludes specifically forestry, agriculture, mining, clean technologies and life sciences":
    "Matériaux d'avant-garde et fabrication Exclut spécifiquement la sylviculture, l'agriculture, l'exploitation minière, les technologies propres et les sciences de la vie.",
  "Clean Tech: Technologies that protect and/or increase efficient utilization of land, water and air resources":
    "Tech. propres : technologies qui protègent et/ou augmentent l'utilisation efficace des ressources de la terre, de l'eau et de l'air",
  "Consumer Retail": "Consommation de détail",
  "Digital Media & Telecommunications: Digital applications and content and information and communications technologies. Excludes healthcare, agriculture, forestry, mining, financial services, education, social innovation, culture/recreation and energy-related solutions":
    "Médias numériques et télécommunications Applications numériques et technologies de l'information et de communication Exclut les soins de santé, l'agriculture, la sylviculture, l'exploitation minière, les services financiers, l'éducation, l'innovation sociale, la culture et loisirs, et les solutions liées à l'énergie.",
  "Education": "Éducation",
  "Financial Services": "Services financiers",
  "Food & Beverage": "Restauration/production d'aliments et boissons",
  "Forestry": "Foresterie",
  "Life Sciences & Health": "Sciences de la vie et de la santé",
  "Mining, Oil & Gas: Includes extractive activities that would not otherwise fall under clean technologies":
    "Exploitation minière, pétrole et gaz : Comprend les activités d'extraction qui ne relèveraient pas autrement des technologies propres",
  "Tourism & Culture: Includes entertainment and sports":
    "Culture et tourisme : comprend le divertissement et le sport",
  "Transportation": "Transport",
  "Other": "Autre",
};

const helpers = makeOptionHelpers(FIRM_INDUSTRY_VALUES, INDUSTRY_FR_TEXT);

export const INDUSTRY_OPTIONS: SelectionData[] = helpers.options;

// industriesOfFocus is stored as a single string across the stack; the firm
// profile multi-select round-trips it through this delimiter. "; " is safe
// because no industry option contains it (values use commas/colons only).
export const INDUSTRIES_DELIMITER = FIRM_OPTIONS_DELIMITER;

// Tokenizes a stored industries string (review R18): comma-aware and
// case-insensitive against the canonical list, and PRESERVES unmatched legacy
// free-text tokens verbatim instead of collapsing them to "Other". Legacy
// values like "SaaS, Hardware, Biotech" survive a form round-trip intact.
export const parseIndustries: (value?: string) => string[] = helpers.parse;

export const serializeIndustries: (values: string[]) => string = helpers.serialize;

// ── Render-time display mapping (review R20) ─────────────────────────
// Stored values are the English canonical strings; FR mode maps them through
// frText at render time. Preserved legacy free-text tokens render verbatim.

export const displayIndustry: (token: string, lang: LangState) => string = helpers.display;

export const displayIndustries: (value: string | undefined, lang: LangState) => string =
  helpers.displayList;
